import { LETTER_POINTS } from '../../features/scrabble/config/gameConfig';

export const EVENT_NAMES = {
  RUN_STARTED: 'run_started',
  RUN_RESUMED: 'run_resumed',
  SUBMIT_WORD: 'submit_word',
  ROUND_COMPLETED: 'round_completed',
  ACT_COMPLETED: 'act_completed',
  DISCARD_CONFIRMED: 'discard_confirmed',
  SHOP_VISITED: 'shop_visited',
  SHOP_OPTIONS_DRAWN: 'shop_options_drawn',
  SHOP_OPTION_CONFIRMED: 'shop_option_confirmed',
  SHOP_SKIPPED: 'shop_skipped',
  SHOP_REROLLED: 'shop_rerolled',
  RUN_ABANDONED: 'run_abandoned',
  VICTORY: 'victory',
};

export const mapTileForAnalytics = (letter, modifiers) => {
  const normalizedLetter = String(letter || '').toUpperCase();
  const baseScore = Number(LETTER_POINTS[normalizedLetter]) || 0;
  const scoreModifier = Number(modifiers?.score) || 0;
  const multiplier = Math.max(1, Number(modifiers?.multiplier) || 1);
  const extras = Array.isArray(modifiers?.extras) ? [...modifiers.extras] : [];
  return {
    letter: normalizedLetter,
    baseScore,
    scoreModifier,
    multiplier,
    extras,
    effectiveScore: baseScore + scoreModifier,
  };
};

export const mapShopOptionForAnalytics = (option) => {
  const hasTile = option.tileLetter != null;
  const tile = hasTile
    ? mapTileForAnalytics(option.tileLetter, option.tileModifiers)
    : null;
  const grantedEffectTypes = Array.isArray(option.grantedEffects)
    ? option.grantedEffects.map((e) => e.type).filter(Boolean)
    : [];
  return {
    id: option.id ?? null,
    kind: option.kind,
    rarity: option.rarity,
    modifierId: option.modifierId ?? null,
    modifierLabel: option.modifierLabel ?? null,
    title: option.title ?? null,
    tile,
    grantedEffectTypes,
  };
};
